 export const SERVICE_URL = 'https://service.jp-bestelsysteem.nl';

//export const SERVICE_URL = 'http://localhost:3001';
export const DEFAULT_SERVICE_VERSION = 'v1';
